var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArticleTable',{staticClass:"recently-published",attrs:{"heading":"Recently Published","articles":_vm.recent,"hide":['stage'],"date-label":"Published","date-field":"published_at"}})}
var staticRenderFns = []

export { render, staticRenderFns }